










































































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import ProposalProgress from '@/modules/direct-sales/components/proposal-progress/proposal-progress.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { stringService, httpService, traceLogAccess } from '@/services';
import _ from 'lodash';
import moment from 'moment';
import { httpMixin, momentMixin, numeralMixin } from '@/modules/neodash/mixins';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import { CONFIG } from '@/config';
import { Http } from '@/decorators';
import { AUTH_GET_TOKEN, AUTH_GET_USERNAME } from '@/store/modules/authentication/types';
import { GET_LOADING } from '@/store/types';
import { Getter } from 'vuex-class';
import ProjectLoader from '@/modules/dap/components/project-loader/project-loader.vue';
import { notificationService } from '../../../../services';
import PageLoader from '@/components/page-loader/page-loader.vue';
import numeral from 'numeral';
import { PageContextName } from '@/enums';

@Component({
  subscriptions() {
    return {
      searchValue$: this.$watchAsObservable('state.searchValue').pipe(
        pluck('newValue'),
        debounceTime(1100),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ProposalProgress,
    ActionBar,
    PageLoader
  }
})
export default class DirectSalesProposalsCreatePage extends Vue {
  @Prop({ required: false })
  proposalId: number;

  @Prop({ required: false })
  search: string;

  @Prop({ required: false })
  idGroup: number;

  @Prop({ required: false })
  idStore: number;

  @Getter(AUTH_GET_USERNAME)
  public userName: string;

  @Getter(GET_LOADING)
  isLoading: boolean;

  @Getter(AUTH_GET_TOKEN)
  public userToken: string;

  public searchValue$: string = '';

  public moment = moment;

  public numeral = numeral;

  public cpfCnpj_invalid: boolean = false;

  public cpfCnpj_exist: boolean = false;

  public openConfiramation: boolean = false;

  public state: any = {
    searchValue: '',
    data: [],
    currentPage: 1,
    newClient: {},
    salesChannel: [],
    // consumerGroups: [],
    city: [],
    uf: '',
    currentPolicy: true
  };

  public get customersList() {
    const perPage = 8;
    const clients = _(this.state.data)
      .chunk(perPage)
      .value();

    const totalPages = clients.length;
    const page = this.state.currentPage > totalPages ? 1 : this.state.currentPage;
    const pages = [page];
    const pagesTotal = totalPages < 5 ? totalPages : 5;

    if (totalPages > 1) {
      let isLeft = true;
      while (pages.length < pagesTotal) {
        if (isLeft && pages[0] > 1) {
          pages.splice(0, 0, pages[0] - 1);
        } else if (pages[pages.length - 1] < totalPages) {
          pages.push(pages[pages.length - 1] + 1);
        }
        isLeft = !isLeft;
      }
    }

    return {
      page: page,
      perPage: perPage,
      offset: (page - 1) * perPage,
      total: this.state.data ? this.state.data.length : 0,
      totalPages,
      pages,
      data: clients[this.state.currentPage - 1]
    };
  }

  public getProposal() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/${this.proposalId}/GetProposal`)
      .then((res: AxiosResponse) => {
        this.state.searchValue = res.data.nameConsumer.trim();
        this.searchValue$ = this.state.searchValue.trim();
        this.request();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  @Watch('searchValue$')
  public request() {
    let valueRequest = '';
    if (parseInt(this.searchValue$.replace(/(\.|\/|\-)/g, ''))) {
      valueRequest = this.searchValue$ ? this.searchValue$.replace(/(\.|\/|\-)/g, '') : '';
    } else {
      valueRequest = this.searchValue$ ? this.searchValue$ : '';
    }

    this.state.data = [];
    if (valueRequest.length > 2) {
      httpService.http
        .get(`${CONFIG.URL.NEODASH_API}/api/directsales/consummer/${valueRequest}`)
        .then((res: AxiosResponse) => {
          this.state.data = _.map(res.data, (d: any) => ({
            id: d.id,
            name: d.name,
            cnpj: d.cpfCnpj,
            units: d.qtdPurchase,
            unitsRoot: d.qtdPurchaseCnpjRoot,
            city: d.city,
            uf: d.uf,
            updatedAt: d.lastPurchase ? moment(d.lastPurchase).format('DD/MM/YYYY') : '',
            descriptionSalesChannel: d.descriptionSalesChannel
          }));
        })
        .catch((err: AxiosError) => console.log(err.message));
    }
  }

  public formatarCampo(cpfCnpj) {
    cpfCnpj = cpfCnpj.replace(/(\.|\/|\-)/g, '');
    if (cpfCnpj.length <= 11) {
      cpfCnpj = this.mascaraCpf(cpfCnpj);
    } else {
      cpfCnpj = this.mascaraCnpj(cpfCnpj);
    }
    return cpfCnpj;
  }

  public mascaraCpf(valor: string) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  public mascaraCnpj(valor: string) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  }

  private cancelModalCliente() {
    this.openConfiramation = false;
    this.clearObjects();
  }

  private confirmModalNewClient() {
    this.saveCustomer();
  }

  public opemModalNewClient() {
    this.clearObjects();
    this.openConfiramation = true;
    this.getSalesChannel();
    this.getCitiesUf();
  }

  public clearObjects() {
    this.cpfCnpj_invalid = false;
    this.cpfCnpj_exist = false;
    this.state.newClient = {};
  }

  public getSalesChannel() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/saleschannel`)
      .then((res: AxiosResponse) => {
        this.state.salesChannel = res.data;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getCitiesUf() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/cities`)
      .then((res: AxiosResponse) => {
        this.state.city = res.data;
        this.getUFs();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getUFs() {
    return _(this.state.city)
      .map(m => {
        return {
          value: _.split(m.name, ',', 2)[1],
          text: _.split(m.name, ',', 2)[1]
        };
      })
      .filter((d: any) => d.value)
      .uniqBy((d: any) => d.value)
      .orderBy((o: any) => o.text)
      .value();
  }

  public cleanCity() {
    if (this.state.newClient.geoCode) {
      this.state.newClient.geoCode = '';
    }
  }

  public getCities() {
    return _(this.state.city)
      .filter((f: any) => _.split(f.name, ',', 2)[1] == this.state.newClient.uf)
      .map(m => {
        return {
          value: m.geocodigo,
          text: _.split(m.name, ',', 2)[0]
        };
      })
      .filter((d: any) => d.value)
      .uniqBy((d: any) => d.value)
      .orderBy((o: any) => o.text)
      .value();
  }

  public saveCustomer() {
    if (!this.state.newClient || !this.state.newClient.cpfCnpj) return;

    this.state.newClient.cpfCnpj = this.state.newClient.cpfCnpj.replace(/(\.|\/|\-)/g, '');

    const city = _(this.state.city)
      .filter((f: any) => f.geocodigo == this.state.newClient.geoCode)
      .value();

    this.state.newClient.city = _.split(city[0]['name'], ',', 2)[0];

    if (this.validCPFANDCNPJ()) {
      httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/directsales/consummer`, this.state.newClient)
        .then((res: AxiosResponse) => {
          if (res.data == 0) {
            this.cpfCnpj_exist = true;
          } else {
            this.request();
            this.cancelModalCliente();
            notificationService.sendToast({
              status: 1,
              type: 'success',
              message: 'Cliente cadastrado com sucesso!'
            });
          }
        })
        .catch((err: AxiosError) => console.log(err.message));
    } else {
      this.state.newClient.cpfCnpj = '';
      this.cpfCnpj_invalid = true;
    }
  }

  public validCPFANDCNPJ() {
    if (!this.state.newClient.cpfCnpj) {
      return false;
    }

    this.cpfCnpj_exist = false;
    const value = this.state.newClient.cpfCnpj.replace(/(\.|\/|\-)/g, '');

    let valid = false;
    if (value.length == 11) {
      valid = this.validCPF(value);
    } else if (value.length == 14) {
      valid = this.validCNPJ(value);
    }

    this.cpfCnpj_invalid = valid ? false : true;

    if (this.cpfCnpj_invalid) {
      this.state.newClient.cpfCnpj = '';
    }

    return valid;
  }

  public validCPF(cpf: any) {
    if (
      !cpf ||
      cpf.length != 11 ||
      cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999'
    )
      return false;
    let soma = 0;
    let resto;
    for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(cpf.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(cpf.substring(10, 11))) return false;
    return true;
  }

  public validCNPJ(cnpj: any) {
    if (
      !cnpj ||
      cnpj.length != 14 ||
      cnpj == '00000000000000' ||
      cnpj == '11111111111111' ||
      cnpj == '22222222222222' ||
      cnpj == '33333333333333' ||
      cnpj == '44444444444444' ||
      cnpj == '55555555555555' ||
      cnpj == '66666666666666' ||
      cnpj == '77777777777777' ||
      cnpj == '88888888888888' ||
      cnpj == '99999999999999'
    )
      return false;
    let tamanho = cnpj.length - 2;
    let numeros: any = cnpj.substring(0, tamanho);
    let digitos: any = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;
    return true;
  }

  public goToSetupProposal(item: any) {
    if (item.unitsRoot > 100) {
      notificationService.sendToast({
        type: 'error',
        status: 0,
        message:
          'O total de veículos mais o total de compras já efetuadas nos últimos 4 anos ultrapassaram 100 unidades, entre em contato com a Toyota.'
      });
    } else {
      this.$router.push({
        name: DIRECT_SALES_ROUTES.PROPOSALS_AVAILABILITY,
        params: {
          consumerId: String(item.id),
          proposalId: String(this.proposalId)
        }
      });
    }
  }

  public goToListClients() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.LIST_CLIENTS,
      params: {
        idGroup: String(this.idGroup),
        idStore: String(this.idStore)
      }
    });
  }

  public goToHistoricClient(item: any) {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.HISTORIC_CLIENT,
      params: {
        consumerId: String(item.id),
        proposalId: String(this.proposalId),
        search: String(this.searchValue$)
      }
    });
  }

  public goBack() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS
    });
  }

  public getCurrentPolicy() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/politics/currentPolicy`)
      .then((res: AxiosResponse) => {
        this.state.currentPolicy = res.data;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public mounted() {
    traceLogAccess.generationTracking(PageContextName.directSalesAssistantSearchClient);
    this.getCurrentPolicy();
    if (this.search && this.search != 'undefined' && this.search.length > 0) {
      this.searchValue$ = this.search;
      this.state.searchValue = this.search;
    }

    if (this.proposalId) {
      this.getProposal();
    }
  }
}
